import React from 'react';
import { Stack, Typography, Chip } from '@mui/material';
import { SwapVertRounded } from '@mui/icons-material';
import { useTheme } from '@mui/system';
import { formatCurrency } from '../../../../utils/formatNumbers';

function ReplacementOptimizationBody({ recommendation }) {
    const theme = useTheme();
    const currentItem = recommendation.item;
    const suggestedItem = recommendation.recommended_item;
    // Hard-coded until contract context is provided by the API.
    const isInContract = true;

    return (
        <Stack spacing={1}>
            <ItemSummaryRow label='Current Item' item={currentItem} color={theme.palette.subtext.main} />
            <Stack alignItems='center'>
                <SwapVertRounded fontSize='small' style={{ color: theme.palette.subtext.main }} />
            </Stack>
            <ItemSummaryRow label='Suggested Item' item={suggestedItem} color={theme.palette.blue.main} />
            { isInContract &&
                <Chip
                    label='In Contract'
                    size='small'
                    sx={{
                        alignSelf: 'flex-start',
                        backgroundColor: theme.palette.itemSwapChip.background.positive,
                        color: theme.palette.itemSwapChip.text.positive,
                        fontSize: '11px'
                    }}
                />
            }
        </Stack>
    );
}

function ItemSummaryRow({ label, item, color }) {
    const theme = useTheme();
    return (
        <Stack spacing={0.25}>
            <Typography variant='bold' sx={{ fontSize: '11px', color, textTransform: 'uppercase' }}>{label}</Typography>
            <Typography variant='normal' noWrap sx={{ fontSize: '13px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item?.name}</Typography>
            <Typography variant='normal' sx={{ fontSize: '12px', color: theme.palette.subtext.main }}>
                {item?.vendor?.name} · {formatCurrency(item?.cost ?? 0)} · Open Qty: {item?.open_quantity ?? 0}
            </Typography>
        </Stack>
    );
}

export default ReplacementOptimizationBody;
